import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, inject, ViewChild, ViewContainerRef } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {

  componentFactoryResolver: ComponentFactoryResolver = inject(ComponentFactoryResolver)

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) container!: ViewContainerRef;

  ngOnInit(){
    this.loadComponent()
  }

  async loadComponent() {
    const { HeaderContainer } = await import('../lib/shared/features/header/header.container'); 
  
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(HeaderContainer);
    const componentRef = this.container.createComponent(componentFactory);
  }
}